import { TransitionProps } from "@mui/material/transitions";
import DialogComponent from "../../../../../../common/components/functional/dialogs/DialogComponent";
import { CustomerContract } from "../../../../customerAPI";
import PricingPerTesForm, { PricingPerTesData } from "../../PricingPerTesForm";
import PricingGeneralSettingsForm, {
  PricingGeneralSettingsData,
} from "../generalSettings/PricingGeneralSettingsForm";

const DRAG_HANDLE_SELECTOR = "drag-handle-pricing-edit";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  openedFromPricingContent?: boolean;
  isGeneralPricingModal: boolean;
  contractData: CustomerContract;
  eezyCompanyName: string;
  pricingPerTesData: PricingPerTesData;
  pricingGeneralSettingsData: PricingGeneralSettingsData;
  TransitionProps?: TransitionProps;
}

const PricingEditModal = ({
  isOpen,
  onClose,
  openedFromPricingContent,
  isGeneralPricingModal,
  contractData,
  eezyCompanyName,
  pricingPerTesData,
  pricingGeneralSettingsData,
  TransitionProps,
}: Props) => {
  return (
    <DialogComponent
      variant="card"
      open={isOpen}
      onClose={() => onClose()}
      sx={{ minWidth: "963px" }}
      dragHandleSelector={DRAG_HANDLE_SELECTOR}
      TransitionProps={TransitionProps}
    >
      {isGeneralPricingModal ? (
        <PricingGeneralSettingsForm
          openedFromPricingContent
          contractData={contractData}
          pricingGeneralSettingsData={pricingGeneralSettingsData}
          eezyCompanyName={eezyCompanyName}
          closeModal={() => onClose()}
        />
      ) : (
        <PricingPerTesForm
          openedFromPricingContent
          contractData={contractData}
          pricingPerTesData={pricingPerTesData}
          eezyCompanyName={eezyCompanyName}
          closeModal={() => onClose()}
        />
      )}
    </DialogComponent>
  );
};

export default PricingEditModal;
